import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IObjectType from '../interfaces/IObjectType';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IObjectType>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'object-type'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Object type successfully created!'}  
        title={'Add object type'}  
        subheader={'Add object type'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
